import { ReactElement } from 'react'
import { ArrowRight } from '../../../assets/arrow-right'
import styles from './list-wrapper.module.css'
import cx from 'classnames'

export interface ListWrapper {
  children: ReactElement | null
  heading?: string
  href?: string
  urlText?: string
  isListCard?: boolean
  handleTrackEvent?: () => void
  hideLinkArrow?: boolean
  headingWithTopPadding?: boolean
}

export const ListWrapper = ({
  children,
  heading,
  urlText,
  href,
  isListCard,
  handleTrackEvent,
  hideLinkArrow,
  headingWithTopPadding = true,
}: ListWrapper) => {
  const handleLinkTrackingEvent = () => {
    handleTrackEvent && handleTrackEvent()
  }

  return (
    <>
      {heading && (
        <h2
          className={cx(
            !isListCard ? styles.heading : styles.listCardHeading,
            headingWithTopPadding ? styles.headingTopPadding : '',
          )}
        >
          {heading}
        </h2>
      )}
      <ul className={styles.listWrapperContainer}>
        {children}
        {urlText && (
          <li>
            <a
              className={
                !isListCard ? styles.wrapperLink : styles.listCardWrapperLink
              }
              href={href}
              onClick={handleLinkTrackingEvent}
            >
              <div className={isListCard ? styles.listCardUrlText : ''}>
                {urlText}
              </div>
              {!hideLinkArrow && (
                <div className={styles.wrapperLinkIcon}>
                  <ArrowRight />
                </div>
              )}
            </a>
          </li>
        )}
      </ul>
    </>
  )
}
